<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div class="row">
          <div class="col-lg-12">
            <h1>Estatísticas</h1>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-graduation-cap" /> Assistentes ativas</div>
                    <h2>{{ stats.assistants_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-user" /> Clientes ativos</div>
                    <h2>{{ stats.clients_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-briefcase" /> Projetos ativos</div>
                    <h2>{{ stats.projects_count }}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-file-alt" /> Propostas ativas</div>
                    <h2>{{ stats.proposals_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-handshake" /> Contratações</div>
                    <h2>{{ stats.hires_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-star" /> Feedbacks</div>
                    <h2>{{ stats.reviews_count }}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <h1>Relatórios</h1>

            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allAssistants()">
                    Lista de assistentes
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allClients()">
                    Lista de clientes
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allProjects()">
                    Lista de projetos
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allReleasedContacts()">
                    Lista de propostas aceitas
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allHires()">
                    Lista de contratações
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allReviews()">
                    Lista de feedbacks
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="introAvFunnel()">
                    Funil - Explorando
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="buildFunnel()">
                    Funil - Começando
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="growthFunnel()">
                    Funil - Já atua
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allCustomers()">
                    Lista de compradores
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="checkoutVisitors()">
                    Visitaram o checkout
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="buildFunnelIntroAv()">
                    Funil - Começando - Curso Gratuito
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <h1>Tarefas</h1>

            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="syncOrders()">
                    Sincronizar faturas
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="syncHires()">
                    Sincronizar contratações
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="syncStreaming()">
                    Sincronizar streaming
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="addAccess()">
                    Liberar acesso
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="generatePaymentLink()">
                    Gerar link de pagamento
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="syncStripe()">
                    Sincronizar Stripe
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="resetOffers()">
                    Resetar ofertas
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AdminManager from "../../../js/services/admin.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "DashboardPage");
    this.$store.commit("setActiveProjectList", null);
    this.loadAdminData();
  },

  data() {
    return {
      profile: null,
      stats: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  methods: {
    async loadAdminData() {
      this.$store.commit("setLoading", true);

      try {
        let adminData = await AdminManager.getAdminData();
        this.profile = adminData.profile;

        if (!this.profile) {
          window.location = "/cadastro";
        } else {
          this.stats = adminData.stats;
          this.$store.commit("setActiveUser", this.profile);
          this.$store.commit("setLoading", false);
        }
      } catch (error) {
        this.handleAPIError(error, null);
      }
    },

    allCustomers() {
      let url = `${Config.apiHost}/admin/reports/customers`;
      window.open(url);
    },
    allAssistants() {
      let url = `${Config.apiHost}/admin/reports/assistants`;
      window.open(url);
    },

    allClients() {
      let url = `${Config.apiHost}/admin/reports/clients`;
      window.open(url);
    },

    allProjects() {
      let url = `${Config.apiHost}/admin/reports/projects`;
      window.open(url);
    },

    allReleasedContacts() {
      let url = `${Config.apiHost}/admin/reports/accepted-proposals`;
      window.open(url);
    },

    allHires() {
      let url = `${Config.apiHost}/admin/reports/hires`;
      window.open(url);
    },

    allReviews() {
      let url = `${Config.apiHost}/admin/reports/reviews`;
      window.open(url);
    },

    introAvFunnel() {
      let url = `${Config.apiHost}/admin/reports/intro-av-funnel`;
      window.open(url);
    },

    buildFunnel() {
      let url = `${Config.apiHost}/admin/reports/build-funnel`;
      window.open(url);
    },

    buildFunnelIntroAv() {
      let url = `${Config.apiHost}/admin/reports/build-funnel-intro-av`;
      window.open(url);
    },

    growthFunnel() {
      let url = `${Config.apiHost}/admin/reports/growth-funnel`;
      window.open(url);
    },

    checkoutVisitors() {
      let url = `${Config.apiHost}/admin/reports/checkout-visitors`;
      window.open(url);
    },

    syncStripe() {
      AdminManager.syncStripe();
    },

    syncOrders() {
      AdminManager.syncOrders();
    },

    syncNFs() {
      let url = `${Config.apiHost}/admin/sync-nfs`;
      window.open(url);
    },

    syncHires() {
      let url = `${Config.apiHost}/admin/sync-hires`;
      window.open(url);
    },

    syncStreaming() {
      let url = `${Config.apiHost}/admin/sync-streaming`;
      window.open(url);
    },

    resetOffers() {
      AdminManager.resetOffers();
    },

    generateJobPostsForSEO() {
      let url = `${Config.apiHost}/admin/generate-jobposts-seo`;
      window.open(url);
    },

    generateJobPostsForLP() {
      let url = `${Config.apiHost}/admin/generate-jobposts-lp`;
      window.open(url);
    },

    generatePaymentLink() {
      let $ctx = this;
      let $modal = $("#generatePaymentLinkModal");
      $modal.find(".item").removeClass("error");

      function addOrUpdateQueryParam(url, key, value) {
        const u = new URL(url, window.location.origin);
        u.searchParams.set(key, value);
        return u.toString();
      }

      let action = async function () {
        let hasError = false;
        $modal.find(".item").removeClass("error");

        const preco = parseFloat(document.getElementById("preco").value) || 0;
        const precoCentavos = Math.round(preco * 100);
        const orderReference = $("#link_order_reference").val();
        const linkDuration = Number($("#link_duration").val()) * 3600;

        const installments = [[precoCentavos, precoCentavos]];

        document.querySelectorAll("tbody tr").forEach((row) => {
          const parcelaCentavos = parseInt(row.dataset.parcelaCentavos) || 0;
          const totalCentavos = parseInt(row.dataset.totalCentavos) || 0;

          installments.push([parcelaCentavos, totalCentavos]);
        });

        let details = {
          orderRef: orderReference.toUpperCase(),
          installments,
        };

        if (hasError) {
          return false;
        }

        let response = await AdminManager.generatePaymentLink(linkDuration, details);
        let url = addOrUpdateQueryParam(
          `${Config.publicSite}/comprar`,
          "rsrc",
          response.token
        );
        window.open(url);
        return true;
      };

      this.showModal(
        $modal,
        function () {},
        "Gerar link",
        action,
        "Link gerado.",
        "Ocorreu um erro gerar o link.\nPor favor, tente novamente."
      );
    },

    addAccess() {
      let $ctx = this;
      let $modal = $("#addAccessModal");
      $modal.find(".item").removeClass("error");

      let action = async function () {
        let hasError = false;
        $modal.find(".item").removeClass("error");

        let $name = $modal.find("[data-name]");
        let $email = $modal.find("[data-email]");
        let $phone = $modal.find("[data-phone]");
        let $order_reference = $modal.find("[data-order-ref]");
        let $notes = $modal.find("[data-notes]");

        let details = {
          name: $name.val().trim(),
          email: $email.val().toLowerCase().trim(),
          phone: $phone.val().trim(),
          order_ref: $order_reference.val(),
          notes: $notes.val().trim(),
        };

        if (StringUtils.isEmpty(details.name) || details.name.length < 10) {
          $name.closest(".item").addClass("error");
          hasError = true;
        }

        if (!$ctx.validateEmail(details.email)) {
          $email.closest(".item").addClass("error");
          hasError = true;
        }

        if (!$ctx.validatePhone(details.phone)) {
          $phone.closest(".item").addClass("error");
          hasError = true;
        }

        if (StringUtils.isEmpty(details.notes) || details.notes.length < 10) {
          $notes.closest(".item").addClass("error");
          hasError = true;
        }

        if (hasError) {
          return false;
        }
        let response = await AdminManager.addAccess(details);
        window.open("/assistente/" + response.assistantId);
        return true;
      };

      this.showModal(
        $modal,
        function () {},
        "Liberar acesso",
        action,
        "Acesso liberado!",
        "Ocorreu um erro liberar o acesso.\nPor favor, tente novamente."
      );
    },
  },
};
</script>
